// ** redux imports
import { createSlice } from '@reduxjs/toolkit';

// initial states
const initialState = {
  uploadProgress: {},
  selectedDocuments: [],
};

export const documentsSlice = createSlice({
  name: 'documents',
  initialState,
  reducers: {
    setUploadProgress: (state, { payload }) => {
      const { documentId, progress } = payload;
      state.uploadProgress[documentId] = progress;
    },
    clearUploadProgress: (state, { payload }) => {
      const documentId = payload;
      delete state.uploadProgress[documentId];
    },
    setSelectedDocuments: (state, { payload }) => {
      state.selectedDocuments = payload;
    },
    clearSelectedDocuments: state => {
      state.selectedDocuments = [];
    },
  },
});

export const {
  setUploadProgress,
  clearUploadProgress,
  setSelectedDocuments,
  clearSelectedDocuments,
} = documentsSlice.actions;

export default documentsSlice.reducer;
